module.exports = __webpack_public_path__ + "3760646934de106799599ab6c22127a9.svg";